import {mapState, mapActions} from 'vuex'
import router from '../router'
import * as RoutePathConstants from '../constants/RoutePathConstants'
import sessionStorageUtil from '../common/utils/sessionStorageUtil'
import {Message} from 'element-ui'

export default {
  name: 'App',
  data () {
    return {
    }
  },
  methods: {
    ...mapActions([]),
  },
  computed: {
    ...mapState([]),
    appStyle () {
      return {
        'min-height': `${document.documentElement.clientHeight}px`,
        'position': 'relative'
      }
    },
    appStyle2 () {
      // console.log(document.documentElement.clientHeight)
      return {
        'min-height': `${document.documentElement.clientHeight - 75}px`
        // 'min-height': `1000px`
      }
    }
  },
  mounted: function () {
  }
}



// WEBPACK FOOTER //
// ./src/pages/app.js